import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  mainContainer: {
    padding: 10,
  },
  titleTypo: {
    marginTop: 10,
    fontSize: 30,
    fontWeight: 800,
  },
  baseInfoGrid: {
    marginTop: 20,
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  mapContainer: {
    width: "100%",
    height: 250,
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
  createButton: {
    // marginTop: 10,
  },
  formContainer: {
    borderRadius: 20,
    border: "1px solid #75757522",
    padding: 10,
    marginBottom: 20,
  },
  formBodyTypo: {
    marginBottom: 10,
    fontSize: 20,
    fontWeight: 300,
  },
  formsContainer: {
    marginTop: 20,
    // padding: 20,
  },
}));
